module.exports = __webpack_public_path__ + "media/images/home/ic_email-cd035ce1e0b43bccef51d8fc1edeb06e.svg";